import { render, staticRenderFns } from "./AccountEnquiryForm.vue?vue&type=template&id=06552eb8&scoped=true&"
import script from "./AccountEnquiryForm.vue?vue&type=script&lang=js&"
export * from "./AccountEnquiryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06552eb8",
  null
  
)

export default component.exports